const all = `
SELECT _id AS "DB ID", storeCode AS "Store Code", businessname as "Business Name",
city AS "City", state AS "State",
vendor->'yelp'->>'url' as "YELP URL",
vendor->'mapquest'->>'url' as "MAPQUEST URL",
vendor->'pandio'->>'urls' as "YP/DEX/SP URLs",
vendor->'applemaps'->>'placeCardUrl' as "APPLEMAPS URL",
vendor->'bing'->>'url' as "Bing URL",
vendor->'gmb'->>'mapsUri' as "GMB URL",
vendor->'nextdoor'->>'url' as "NEXTDOOR URL",
vendor->'tripadvisor'->>'profileUri' as "TRIPADVISOR URL",
vendor->'tomtom'->>'url' as "TOMTOM URL",
vendor->'factual'->>'url' as "FACTUAL URL",
vendor->'here'->>'url' as "HERE URL",
vendor->'pandio'->>'url' as "PANDIO URL",
vendor->'amazonalexa'->>'url' as "AMAZONALEXA URL",
vendor->'facebook'->>'url' as "FACEBOOK URL",
vendor->'infogroup'->>'url' as "INFOGROUP URL",
vendor->'localeze'->>'url' as "LOCALEZE URL",
vendor->'uber'->>'url' as "UBER URL",
vendor->'ypca'->>'url' as "YPCA URL",
vendor->'foursquare'->>'url' as "FOURSQUARE"
FROM location
WHERE  _status = 'A' AND _pubstatus = 'Y' ORDER BY storeCode
`;
export const LISTINGS_SQL = { all };
